import NachWrapper from 'features/nach/components/NachWrapper';
import BankDetails from './BankDetails';
import { Button, Form, message, Tooltip } from 'antd';
import { useCallback, useState } from 'react';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import {
  getNachMandateDetailsResponseData,
  nachBankDetailType,
  nachRequestType,
  razorpayNachSetup,
} from 'api/nach';
import { customer_routes } from '../routes';
import { useNavigate } from 'react-router-dom';
import Loading from 'features/nach/components/Loading';
import { getTodayTo25YearsTimestamp } from 'features/nach/utils/getTimestamp';
// import { getTodayTo25YearsTimestamp } from 'features/nach/utils/getTimestamp';

type Props = {
  bankData: nachBankDetailType;
  mandateLinkData: getNachMandateDetailsResponseData;
  mandateId: string;
};

function Pnach({ bankData, mandateId, mandateLinkData }: Props) {
  const [prefilledForm, setPrefilledForm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [pnachBankCode, setPnachBankCode] = useState<string | undefined>(undefined);
  const [branchName, setBranckName] = useState<string | undefined>(undefined);

  const [razorpaySetUp, setRazorpaySetUp] = useState({ id: '', cust_id: '' });

  const [form] = Form.useForm();
  const [Razorpay] = useRazorpay();
  const navigate = useNavigate();

  const handleSetBankCode = (code: string) => {
    setPnachBankCode(code);
  };
  const handleBranchName = (name: string) => {
    setBranckName(name);
  };

  const handlePayment = useCallback(
    (order: { id: string; cust_id: string }) => {
      const options: RazorpayOptions = {
        key: import.meta.env.VITE_RAZORPAY_KEY,
        order_id: order.id,
        customer_id: order.cust_id,
        recurring: true,
        currency: 'INR',
        amount: '0',
        name: 'Avanse Corp',
        handler: function (response) {
          goToSummaryPage(response.razorpay_payment_id);
          alert(response.razorpay_payment_id);
          alert(response.razorpay_order_id);
          alert(response.razorpay_signature);
        },
        notes: {
          'note_key 1': 'Beam me up Scotty',
          'note_key 2': 'Tea. Earl Gray. Hot.',
        },
        theme: {
          color: '#F37254',
        },
      };

      const rzpay = new Razorpay(options);
      rzpay.open();
    },
    [Razorpay]
  );

  const goToSummaryPage = (paymentId: string) => {
    console.log(paymentId);
    navigate(customer_routes.nach_payment_summary.to, {
      state: { paymentId: paymentId, mandateId, nachType: '2' },
      replace: true,
    });
  };
  const handleSubmit = () => {
    form
      .validateFields()
      .then((values: nachBankDetailType) => {
        console.log('values ', values);
        const requestData: nachRequestType = {
          name: values.accountHolderName || mandateLinkData.nachUserDetails.customerName,
          email: mandateLinkData.custEMail,
          contact: mandateLinkData.phoneNumber,
          method: 'nach',
          mandateid: parseInt(mandateId),
          nachtype: 'pnach',
          auth_type: 'physical',
          // amount: mandateLinkData.mandateAmount,
          amount: 0,
          fail_existing: 0,
          max_amount: mandateLinkData.maxBillingAmount,
          // expire_at: Math.round(Date.now() / 1000) + 24 * 7 * 60 * 60,
          expire_at: getTodayTo25YearsTimestamp(),
          bank_account: {
            beneficiary_name: values.accountHolderName || '',
            account_number: values.accountNumber || '',
            account_type: values.accountType || '',
            ifsc_code: values.ifsc || '',
          },
          bankCode: pnachBankCode || '',
          branchName: branchName || '',
          bankName: values.bankName || '',
        };
        if (prefilledForm) {
          handleDownload(prefilledForm);
          return;
        }

        console.log('pnach form data', JSON.stringify(values));
        setIsLoading(true);
        razorpayNachSetup(requestData)
          .then((res) => {
            console.log('razorpay enach ', res);
            if (
              res.status == 'SUCCESS' &&
              res.data &&
              res.data.custid &&
              res.data.orderid &&
              res.data.prefilled_form
            ) {
              setRazorpaySetUp({ id: res.data.orderid, cust_id: res.data.custid });
              setPrefilledForm(res.data.prefilled_form || '');
              handleDownload(res.data.prefilled_form);
            } else {
              message.error('Failed to process');
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };
  const handleDownload = (url: string) => {
    const newTab = window.open(url, '_blank');
    setTimeout(() => {
      if (newTab) {
        newTab.close();
      }
    }, 2000);
  };
  const initiatePayment = () => {
    if (razorpaySetUp.cust_id && razorpaySetUp.id) {
      console.log('order id', razorpaySetUp);
      handlePayment({ id: razorpaySetUp.id, cust_id: razorpaySetUp.cust_id });
    }
  };

  return (
    <div style={{ marginTop: '60px' }}>
      <Loading isLoading={isLoading} />
      <NachWrapper title="P-NACH Bank Details">
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <BankDetails
            nachId={2}
            nachBankData={bankData as any}
            form={form}
            setEnachBankCode={handleSetBankCode}
            setBranckName={handleBranchName}
            sourceType="P-NACH" // <--- Add this line
          />
          <div
            style={{
              marginTop: '20px',
              display: 'flex',
              gap: '20px',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Button type="primary" onClick={handleSubmit}>
              Download P-NACH Form
            </Button>
            <Tooltip title={prefilledForm ? '' : 'Please download pnach form'}>
              <Button type="primary" disabled={!prefilledForm} onClick={initiatePayment}>
                Proceed
              </Button>
            </Tooltip>
          </div>
        </div>
      </NachWrapper>
    </div>
  );
}

export default Pnach;
